import axios from "axios"

import {ActionService, ApiCallService, apiRequest} from "@libs/ClientService"
import {IGame, IGamePlay} from "@backend/types"

export const gameActions = new ActionService<IGame>("game")

class GameApiCalls extends ApiCallService<IGame> {
    constructor() {
        super("game")
    }

    userGames = (mode?: string) => apiRequest<IGame[]>(axios.get(`${this.resourceUrl}/userGames`, {
        params: {
            mode
        }
    }))

    stats = (gameId: string) => apiRequest<{
        game: IGame,
        gamePlays: IGamePlay[]
    }>(axios.get(`${this.resourceUrl}/${gameId}/stats`))

    airtable = (baseId?: string) => apiRequest<{
        id: string,
        name: string,
        views?: { id: string, name: string }[]
    }[]>(axios.get(`${this.resourceUrl}/airtable/${baseId || ""}`))

    airtableRecords = (baseId: string, tableId: string, view: string) => apiRequest<{
        fields: {
            [k in string]: string
        }
    }[]>(axios.get(`${this.resourceUrl}/airtable/${baseId}/${tableId}/records?view=${view}`))
}

export const gameApiCalls = new GameApiCalls()